import { addProp } from "@pnp/odata";
import { _Group } from "../groups/types.js";
import { Photo } from "./types.js";
addProp(_Group, "photo", Photo);
//# sourceMappingURL=groups.js.map